const custom = () =>{
  // console.log('custom.js')
}
export default custom
